import * as _ from 'underscore'

import { TypeHelper } from "../../helpers/type-helper"

import { OpOperator } from "../core/op-operator"
import { Enums } from "../common"
import { OpDistributor } from "../core"
import { OpOperatorData } from "../core/op-operator-data"

import { IJsonSerializable, ICopyable } from "./interfaces"


//#region IssueOptions

export enum IssueOptions {
    None = 0,
    All = TypeHelper.MAX_INT_VALUE,
    Add = 1,
    Change = 1 << 1,
    Delete = 1 << 2,
    Assigned = 1 << 3,
    Status_NEW = 1 << 4,
    Status_ACCEPTED = 1 << 5,
    Status_QUEUED = 1 << 6,
    Status_IN_PROGRESS = 1 << 7,
    Status_WAITING_FOR_RESPONSE = 1 << 8,
    Status_FINISHED = 1 << 9,
    Status_SUSPENDED = 1 << 10,
    Status_REOPENED = 1 << 11,
    Note_Change = 1 << 12
}

//#endregion


//#region TaskOptions

export enum TaskOptions {
    None = 0,
    All = TypeHelper.MAX_INT_VALUE,
    Add = 1,
    Change = 1 << 1,
    Delete = 1 << 2,
    Assigned = 1 << 3,
    Status_Not_Started = 1 << 4,
    Status_In_progress = 1 << 5,
    Status_WaitingForAcceptance = 1 << 6,
    Status_Finished_succesfully = 1 << 7,
    Status_Finished_with_error = 1 << 8,
    Status_Planned = 1 << 9,
    Status_Canceled = 1 << 10,
    Status_Suspended = 1 << 11,
    Status_Verified = 1 << 12,
    Status_RealizationNotPossible = 1 << 13,
    Status_Rejected = 1 << 14
}

//#endregion


//#region WorkOrderOptions

export enum WorkOrderOptions {
    None = 0,
    All = TypeHelper.MAX_INT_VALUE,
    Add = 1,
    Change = 1 << 1,
    Delete = 1 << 2,
    Assigned = 1 << 3,
    Status_Planned = 1 << 4,
    Status_Accepted = 1 << 5,
    Status_InProgress = 1 << 6,
    Status_Finished = 1 << 7
}

//#endregion


//#region PackageOptions

export enum PackageOptions {
    None = 0,
    All = TypeHelper.MAX_INT_VALUE,
    //Add = 1,
    //Change = 1 << 1,
    // Delete = 1 << 2,
    // Assigned = 1 << 3,
    Status_New = 1 << 4,
    Status_Sent = 1 << 5,
    Status_Wrong = 1 << 6,
    Status_Accepted = 1 << 7,
    Status_Distributed = 1 << 8,
    Status_Removed = 1 << 9,
    Status_NewOrder = 1 << 10,
    Status_Ordered = 1 << 11,
    Status_ToCompletion = 1 << 12,
    Status_InCompletion = 1 << 13,
    // Status_Expired = 1 << 9,
}

//#endregion


//#region LocationOptions

export enum LocationOptions {
    None = 0,
    All = TypeHelper.MAX_INT_VALUE,
    Add = 1,
    Change = 1 << 1,
    Delete = 1 << 2,
    //Assigned = 1 << 3,
    State_NEW = 1 << 4,
    State_SCHEDULED = 1 << 5,
    State_INTERVENTION = 1 << 6,
    State_PENDING = 1 << 7,
    State_OPERATIONAL = 1 << 8,
    State_SUSPENDED = 1 << 9,
    State_UNUSED = 1 << 10,
    State_DELETED = 1 << 11,
    State_APPROVED = 1 << 12
}

//#endregion


//#region NotificationType

export enum NotificationType {
    Issue = 1,
    Task = 2,
    WorkOrder = 3,
    Package = 4,
    ShippingList = 5,
    Location = 6,
}

//#endregion


export class SmsNotificationOptions implements IJsonSerializable, ICopyable<SmsNotificationOptions>  {

    //#region Members

    private issueOptions: number
    private taskOptions: number
    private workOrderOptions: number
    private packageOptions: number
    private locationOptions: number
    private shippingListCloseOptions: number[] = []
    private taskIdDistributorOptions: number[] = []
    private issueIdDistributorOptions: number[] = []
    private locationIdDistributorOptions: number[] = []
    private issueIdIssueTypeOptions: number[] = []

    public owner: OpOperator = null

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        if (opObj instanceof SmsNotificationOptions) {
            this.copy(<SmsNotificationOptions>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    //#endregion


    //#region IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.issueOptions = opObj.issueOptions || IssueOptions.None
            this.taskOptions = opObj.taskOptions || TaskOptions.None
            this.workOrderOptions = opObj.workOrderOptions || WorkOrderOptions.None
            this.packageOptions = opObj.packageOptions || PackageOptions.None
            this.locationOptions = opObj.locationOptions || LocationOptions.None
            this.shippingListCloseOptions = opObj.shippingListCloseOptions
            this.taskIdDistributorOptions = opObj.taskIdDistributorOptions
            this.issueIdDistributorOptions = opObj.issueIdDistributorOptions
            this.locationIdDistributorOptions = opObj.locationIdDistributorOptions
            this.issueIdIssueTypeOptions = opObj.issueIdIssueTypeOptions

            this.owner = opObj.owner != null ? new OpOperator(opObj.owner) : null
        } else {
            this.issueOptions = IssueOptions.None
            this.taskOptions = TaskOptions.None
            this.workOrderOptions = WorkOrderOptions.None
            this.packageOptions = PackageOptions.None
            this.locationOptions = LocationOptions.None
            this.shippingListCloseOptions = []
            this.taskIdDistributorOptions = []
            this.issueIdDistributorOptions = []
            this.locationIdDistributorOptions = []
            this.issueIdIssueTypeOptions = []

            this.owner = null
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            issueOptions: this.issueOptions,
            taskOptions: this.taskOptions,
            workOrderOptions: this.workOrderOptions,
            packageOptions: this.packageOptions,
            locationOptions: this.locationOptions,
            shippingListCloseOptions: this.shippingListCloseOptions,
            taskIdDistributorOptions: this.taskIdDistributorOptions,
            issueIdDistributorOptions: this.issueIdDistributorOptions,
            locationIdDistributorOptions: this.locationIdDistributorOptions,
            issueIdIssueTypeOptions: this.issueIdIssueTypeOptions,

            owmer: this.owner != null ? this.owner.toJSON(compressed) : null
        }
    }

    //#endregion


    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): SmsNotificationOptions {
        const newSmsNotifications = new SmsNotificationOptions(null)

        newSmsNotifications.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newSmsNotifications
    }

    public copy(source: SmsNotificationOptions, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return
        }

        this.issueOptions = source.issueOptions
        this.taskOptions = source.taskOptions
        this.workOrderOptions = source.workOrderOptions
        this.packageOptions = source.packageOptions
        this.locationOptions = source.locationOptions

        this.shippingListCloseOptions = TypeHelper.clone(source.shippingListCloseOptions)
        this.taskIdDistributorOptions = TypeHelper.clone(source.taskIdDistributorOptions)
        this.issueIdDistributorOptions = TypeHelper.clone(source.issueIdDistributorOptions)
        this.locationIdDistributorOptions = TypeHelper.clone(source.locationIdDistributorOptions)
        this.issueIdIssueTypeOptions = TypeHelper.clone(source.issueIdIssueTypeOptions)

        if (includeNavigationProperties) {
            if (source.owner != null) {
                this.owner = source.owner.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
            }
        }
    }

    //#endregion


    //#region Get


    public getLocationNotify(notification: LocationOptions): boolean {
        return this.getNotify(notification, this.locationOptions, LocationOptions.None, LocationOptions.All)
    }

    public getIssueNotify(notification: IssueOptions): boolean {
        return this.getNotify(notification, this.issueOptions, IssueOptions.None, IssueOptions.All)
    }

    public getTaskNotify(notification: TaskOptions): boolean {
        return this.getNotify(notification, this.taskOptions, TaskOptions.None, TaskOptions.All)
    }

    public getWorkOrderNotify(notification: WorkOrderOptions): boolean {
        return this.getNotify(notification, this.workOrderOptions, WorkOrderOptions.None, WorkOrderOptions.All)
    }

    public getPackageNotify(notification: PackageOptions): boolean {
        return this.getNotify(notification, this.packageOptions, PackageOptions.None, PackageOptions.All)
    }

    private getNotify(notification: number, current: number, none: number, all: number): boolean {
        if (notification == all) {
            return current == TypeHelper.MAX_INT_VALUE
        }

        if (notification == none) {
            return current == 0
        }

        return (current & notification) > 0
    }

    //#endregion


    //#region Options

    public getIssueOptions(): number {
        return this.issueOptions
    }

    public getTaskOptions(): number {
        return this.taskOptions
    }

    public getWorkOrderOptions(): number {
        return this.workOrderOptions
    }

    public getLocationOptions(): number {
        return this.locationOptions
    }

    public getPackageOptions(): number {
        return this.packageOptions
    }

    //#endregion


    //#region List Options

    public getShippingListCloseOptions(): number[] {
        return TypeHelper.clone(this.shippingListCloseOptions)
    }

    public getTaskIdDistributorOptions(): number[] {
        return TypeHelper.clone(this.taskIdDistributorOptions)
    }

    public getIssueIdDistributorOptions(): number[] {
        return TypeHelper.clone(this.issueIdDistributorOptions)
    }

    public getLocationIdDistributorOptions(): number[] {
        return TypeHelper.clone(this.locationIdDistributorOptions)
    }

    public getIssueIdIssueTypeOptions(): number[] {
        return TypeHelper.clone(this.issueIdIssueTypeOptions)
    }

    //#endregion


    //#region Set

    public setLocationNotify(notification: LocationOptions): void {
        if (notification === LocationOptions.None) {
            this.locationOptions = 0
        }
        else {
            this.locationOptions |= notification
        }

        if (this.owner != null) {
            this.owner.dataList.setValue(this.locationOptions, Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_LOCATION)
            this.owner.dataList.getData(Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_LOCATION, 0).distributor = this.owner.distributor;
        }
    }

    public setIssueNotify(notification: IssueOptions): void {
        if (notification === IssueOptions.None) {
            this.issueOptions = 0
        }
        else {
            this.issueOptions |= notification
        }

        if (this.owner != null) {
            this.owner.dataList.setValue(this.issueOptions, Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_ISSUE)
            this.owner.dataList.getData(Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_ISSUE, 0).distributor = this.owner.distributor;
        }
    }

    public setTaskNotify(notification: TaskOptions): void {
        if (notification === TaskOptions.None) {
            this.taskOptions = 0
        }
        else {
            this.taskOptions |= notification
        }

        if (this.owner != null) {
            this.owner.dataList.setValue(this.taskOptions, Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_TASK)
            this.owner.dataList.getData(Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_TASK, 0).distributor = this.owner.distributor;
        }
    }

    public setWorkOrderNotify(notification: WorkOrderOptions): void {
        if (notification === WorkOrderOptions.None) {
            this.workOrderOptions = 0
        }
        else {
            this.workOrderOptions |= notification
        }

        if (this.owner != null) {
            this.owner.dataList.setValue(this.workOrderOptions, Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_ROUTE)
            this.owner.dataList.getData(Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_ROUTE, 0).distributor = this.owner.distributor;
        }
    }

    public setPackageNotify(notification: PackageOptions): void {
        if (notification === PackageOptions.None) {
            this.packageOptions = 0
        }
        else {
            this.packageOptions |= notification
        }

        if (this.owner != null) {
            this.owner.dataList.setValue(this.packageOptions, Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_PACKAGE)
            this.owner.dataList.getData(Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_PACKAGE, 0).distributor = this.owner.distributor;
        }
    }

    public setNotify(distributors: OpDistributor[], type: NotificationType): void {
        let idDataType: Enums.DataType = null

        switch (type) {
            case NotificationType.ShippingList:
                idDataType = Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_SHIPPING_LIST_CLOSE
                break

            case NotificationType.Task:
                idDataType = Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_TASK_ID_DISTRIBUTOR
                break

            case NotificationType.Issue:
                idDataType = Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_ISSUE_ID_DISTRIBUTOR
                break

            case NotificationType.Location:
                idDataType = Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_LOCATION_ID_DISTRIBUTOR
                break
        }

        if (idDataType != null) {
            if (_.size(distributors) > 0) {
                const idString: string = _
                    .chain(distributors)
                    .map((distributor: OpDistributor) => distributor.idDistributor.toString())
                    .join(TypeHelper.comma)
                    .value()

                if (this.owner != null) {
                    const existingData: OpOperatorData = this.owner.dataList.getData(idDataType, 0)

                    if (existingData != null) {
                        this.owner.dataList.setValue(idString, idDataType, 0, null, Enums.OpChangeState.Modified);
                    }
                    else {
                        this.owner.dataList.setValue(idString, idDataType, 0);
                    }
                }
            }
            else {
                const data: OpOperatorData = this.owner.dataList.getData(idDataType, 0)

                if (data != null) {
                    data.opState = Enums.OpChangeState.Delete
                }
            }

            const data: OpOperatorData = this.owner.dataList.getData(idDataType, 0)

            if (data != null) {
                data.distributor = this.owner.distributor
            }
        }
    }

    //#endregion


    //#region Reset

    public resetLocationNotify(notification: LocationOptions): void {
        this.locationOptions &= ~notification;

        this.owner.dataList.setValue(this.locationOptions, Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_LOCATION);
    }

    public resetIssueNotify(notification: IssueOptions): void {
        this.issueOptions &= ~notification;

        this.owner.dataList.setValue(this.issueOptions, Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_ISSUE);
    }

    public resetTaskNotify(notification: TaskOptions): void {
        this.taskOptions &= ~notification;

        this.owner.dataList.setValue(this.taskOptions, Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_TASK);
    }

    public resetWorkOrderNotify(notification: WorkOrderOptions): void {
        this.workOrderOptions &= ~notification;

        this.owner.dataList.setValue(this.workOrderOptions, Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_ROUTE);
    }

    public resetPackageNotify(notification: PackageOptions): void {
        this.packageOptions &= ~notification;

        this.owner.dataList.setValue(this.packageOptions, Enums.DataType.OPERATOR_SMS_NOTIFICATION_OPTIONS_PACKAGE);
    }

    //#endregion
}
